import React from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { TransportationRow } from './TransportationTable';
import {
  selectEditableRequirementTypes,
  selectPicklists,
} from '../../../../../../../../../store/redux-store/placement-summary/selectors';
import { InlineAutoComplete } from 'app/components/Common/EditPage/InlineAutoComplete';
import { useArrivedFieldsetMeta } from '../useArrivedFieldsetMeta';
import { CustomTooltip } from '@AMIEWEB/Common';

export const DepartureAirport = () => {
  const { t } = useTranslation();
  const { departureAirport } = useSelector(selectEditableRequirementTypes);
  const fieldsetMeta = useArrivedFieldsetMeta();
  const { airportCodes } = useSelector(selectPicklists);

  return (
    <TransportationRow
      id="placement-offer-transportation-departure-airport"
      label={t('placement.profile.summary.offer.transportation.departureAirport')}
      requirement={departureAirport?.requirement}
      controlComponent={
        <Controller
          name="departureAirport"
          render={({ field }) => (
            <CustomTooltip disabled={!fieldsetMeta.disabled} tooltipContent={fieldsetMeta.title} placement="bottom-start" arrow={false} isStandardContent>
              <InlineAutoComplete
                  {...field}
                  /** Input value is used to override textfield incase DOM is rerendered */
                  inputValue={field.value?.label}
                  options={airportCodes}
                  style={{ maxWidth: '110px' }}
                  isDisabled={fieldsetMeta.disabled}
                />
            </CustomTooltip>
          )}
        />
      }
    />
  );
};
